import { Lightning } from '@lightningjs/sdk';

export class CsaIcon extends Lightning.Component {
  static _template() {
    return {};
  }

  handleIcon() {}
}
